export enum ClauseCategoryStatus {
  IN_PROGRESS = 10,
  DONE = 20,
}

export const CLAUSE_ATTENTION_LEVELS = [
  'NEEDS_ATTENTION',
  'APPEARS_STANDARD',
  'INCONCLUSIVE',
] as const;
export type ClauseAttentionLevel = (typeof CLAUSE_ATTENTION_LEVELS)[number];

export const CLAUSE_IN_FAVOUR_OF = ['CLIENT', 'SUPPLIER', 'NEUTRAL'] as const;
export type ClauseSubcategoryClauseInFavorOf = (typeof CLAUSE_IN_FAVOUR_OF)[number];

export const CLAUSE_RISK_STRATEGIES = ['ACCEPTANCE', 'LIMITATION', 'SHARING', 'TRANSFER'] as const;
export type ClauseSubcategoryClauseClientRiskStrategy = (typeof CLAUSE_RISK_STRATEGIES)[number];

export const CLIENT_RISK_STRATEGY_OPTIONS_TEXT = {
  TRANSFER: { en: 'Transfer', nb: 'Overføring' },
  SHARING: { en: 'Sharing', nb: 'Deling' },
  LIMITATION: { en: 'Limitation', nb: 'Begrensning' },
  ACCEPTANCE: { en: 'Acceptance', nb: 'Aksept' },
};
